import Vue from 'vue'

Vue.filter('capitalize', (value) => {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('formattedDate', (value) => {
  const date = new Date(value)
  return date.toLocaleDateString('en-GB', {
    day: 'numeric', month: 'short', year: 'numeric'
  })
})

Vue.filter('formattedDbAmount', (value, currencySymbol = '', showDecimals = 2, currencyCode = '') => {
  if (!currencySymbol && currencyCode.length > 0) {
    currencyCode = currencyCode.toLowerCase()
    const codeToSymbol = {
      gbp: '£',
      eur: '€',
      usd: '$'
    }
    currencySymbol = codeToSymbol[currencyCode] || ''
  }
  const amount = parseFloat(value / 100).toFixed(showDecimals)
  return `${currencySymbol}${amount}`
})

Vue.filter('formattedDuration', (seconds) => {
  const secondsInHour = 3600
  if (seconds >= secondsInHour) {
    // hh:mm:ss
    return new Date(seconds * 1000).toISOString().substr(11, 8)
  }
  // mm:ss
  return new Date(seconds * 1000).toISOString().substr(14, 5)
})

Vue.filter('formattedNumber', (value) => {
  if (isNaN(value)) return value
  return new Intl.NumberFormat('en-GB').format(value)
})

Vue.filter('yesno', function (value, yes = 'Yes', no = 'No') {
  return value ? yes : no
})
